<template>
    <v-card class="rounded mb-6">
        <div class="py-4 px-6 border-b">
            <p class="text-medium-grey font-bold text-base uppercase mb-3">Detalii per agent</p>
        </div>
        <v-data-table :headers="headers" :items="agents" :loading="loading" hide-default-footer :items-per-page="-1"
            class="agent-breakdown-table">
            <template v-slot:header.pctContractsOffers>
                Oferte
                <v-icon dense color="grey">mdi-arrow-right</v-icon>
                Contracte
            </template>
            <template v-slot:header.pctContractsConfigs>
                Configurări
                <v-icon dense color="grey">mdi-arrow-right</v-icon>
                Contracte
            </template>
            <template v-slot:item.pctContractsConfigs="{ item }">
                <v-chip :color="rateChipColor(item.pctContractsConfigs)" small dark>
                    {{ item.pctContractsConfigs }}%
                </v-chip>
            </template>
            <template v-slot:item.pctContractsOffers="{ item }">
                <v-chip :color="rateChipColor(item.pctContractsOffers)" small dark>
                    {{ item.pctContractsOffers }}%
                </v-chip>
            </template>
            <template v-slot:body.append>
                <tr class="font-weight-bold grey lighten-4">
                    <td class="font-bold">Total echipa</td>
                    <td class="text-center font-bold">{{ totals.configs }}</td>
                    <td class="text-center font-bold">{{ totals.offers }}</td>
                    <td class="text-center font-bold">{{ totals.contracts }}</td>
                    <td class="text-center">
                        <v-chip :color="rateChipColor(totals.pctContractsOffers)" small dark>
                            {{ totals.pctContractsOffers }}%
                        </v-chip>
                    </td>
                    <td class="text-center">
                        <v-chip :color="rateChipColor(totals.pctContractsConfigs)" small dark>
                            {{ totals.pctContractsConfigs }}%
                        </v-chip>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
export default {
    name: 'AgentBreakdownTable',
    props: {
        agents: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
    },
    data() {
        return {
            headers: [
                { text: 'Agent', value: 'name', sortable: true },
                { text: 'Configurări', value: 'configs', align: 'center', sortable: true },
                { text: 'Oferte întocmite', value: 'offers', align: 'center', sortable: true },
                { text: 'Contracte', value: 'contracts', align: 'center', sortable: true },
                { text: 'Oferte Contracte', value: 'pctContractsOffers', align: 'center', sortable: true },
                { text: 'Configurări Contracte', value: 'pctContractsConfigs', align: 'center', sortable: true },
            ],
        };
    },
    computed: {
        totals() {
            const t = this.agents.reduce(
                (acc, a) => {
                    acc.configs += Number(a.configs) || 0;
                    acc.offers += Number(a.offers) || 0;
                    acc.contracts += Number(a.contracts) || 0;
                    return acc;
                },
                { configs: 0, offers: 0, contracts: 0 }
            );
            t.pctContractsConfigs = t.configs > 0 ? parseFloat(((t.contracts / t.configs) * 100).toFixed(1)) : 0;
            t.pctContractsOffers = t.offers > 0 ? parseFloat(((t.contracts / t.offers) * 100).toFixed(1)) : 0;
            return t;
        },
    },
    methods: {
        rateChipColor(pct) {
            if (pct >= 15) return 'green';
            if (pct >= 10) return 'blue';
            return 'gray';
        },
    },
}
</script>
